import React from "react";

/**
 * Uygulama-kökü hata sınırı (Kapı 11-G).
 *
 * Render sırasında bir bileşen istisna atarsa (ör. beklenmeyen/bozuk veri şekli),
 * React tüm ağacı söker ve kullanıcı BEYAZ EKRAN görür. Bu sınır, çökmeyi yakalayıp
 * güvenli, anlaşılır bir Türkçe geri-dönüş ekranı gösterir; stacktrace/teknik
 * detay KULLANICIYA sızmaz (yalnız dev konsoluna loglanır). Böylece "beyaz ekran
 * yok / component ağacı çökmez" güvencesi uygulama genelinde sağlanır.
 */
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Yalnız geliştirici konsoluna; kullanıcıya asla gösterilmez.
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("[AppErrorBoundary] render hatası yakalandı:", error, info);
    }
  }

  handleReload = () => {
    try {
      window.location.reload();
    } catch (_) {
      /* no-op */
    }
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        role="alert"
        data-testid="app-error-boundary"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "#f8fafc",
        }}
      >
        <div
          style={{
            maxWidth: "420px",
            width: "100%",
            textAlign: "center",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            background: "#fff",
            padding: "28px 24px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        >
          <h2 style={{ margin: "0 0 8px", fontSize: "18px", color: "#0f172a" }}>
            Bir sorun oluştu
          </h2>
          <p style={{ margin: "0 0 20px", fontSize: "14px", color: "#475569", lineHeight: 1.5 }}>
            Ekran beklenmedik şekilde yüklenemedi. Sayfayı yenileyip tekrar
            deneyebilirsiniz. Sorun sürerse yöneticinize bildirin.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              cursor: "pointer",
              border: "none",
              borderRadius: "8px",
              background: "#16a34a",
              color: "#fff",
              fontSize: "14px",
              fontWeight: 600,
              padding: "10px 20px",
            }}
          >
            Sayfayı yenile
          </button>
        </div>
      </div>
    );
  }
}
